module.exports = __webpack_public_path__ + "img/list-dropdown.dbe6f3e5.svg";